export function repeatsQuestion(message:string, question:string):boolean {
  const normalize=(value:string)=>value.toLocaleLowerCase('pt-BR').replace(/[^\p{L}\p{N}]+/gu,' ').trim();
  const target=normalize(question);
  return message.includes('?') || (target.length>12 && normalize(message).includes(target));
}
